import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a28c71f2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "card-title m-0" }
const _hoisted_4 = { class: "fw-boldest m-0" }
const _hoisted_5 = { class: "card-body p-9" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-md-6" }
const _hoisted_8 = { class: "form-group d-flex flex-wrap" }
const _hoisted_9 = { class: "col-form-label fw-bold fs-6 required" }
const _hoisted_10 = { class: "col-md-6" }
const _hoisted_11 = { class: "form-group d-flex flex-wrap" }
const _hoisted_12 = { class: "col-form-label fw-bold fs-6 required" }
const _hoisted_13 = { class: "row" }
const _hoisted_14 = { class: "col-md-6" }
const _hoisted_15 = { class: "form-group d-flex flex-wrap" }
const _hoisted_16 = { class: "col-md-6" }
const _hoisted_17 = { class: "form-group d-flex flex-wrap" }
const _hoisted_18 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_19 = { class: "row" }
const _hoisted_20 = { class: "col-md-6" }
const _hoisted_21 = { class: "form-group d-flex flex-wrap" }
const _hoisted_22 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_23 = /*#__PURE__*/_createTextVNode("€")
const _hoisted_24 = { class: "col-md-6" }
const _hoisted_25 = { class: "form-group d-flex flex-wrap" }
const _hoisted_26 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_27 = { class: "row" }
const _hoisted_28 = { class: "col-md-12" }
const _hoisted_29 = { class: "form-group d-flex flex-wrap" }
const _hoisted_30 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_31 = { class: "row" }
const _hoisted_32 = { class: "col-md-6" }
const _hoisted_33 = { class: "form-group d-flex flex-wrap" }
const _hoisted_34 = { class: "required col-form-label fw-bold fs-6" }
const _hoisted_35 = { class: "row" }
const _hoisted_36 = { class: "col-md-12" }
const _hoisted_37 = { class: "form-group d-flex flex-wrap" }
const _hoisted_38 = { class: "col-form-label fw-bold fs-6" }
const _hoisted_39 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2" }, [
  /*#__PURE__*/_createElementVNode("i", {
    style: {"font-size":"1.33rem","padding":"0"},
    class: "fas fa-reply"
  })
], -1))
const _hoisted_41 = {
  type: "submit",
  ref: "submitButton",
  class: "btn btn-primary"
}
const _hoisted_42 = { class: "indicator-label" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2 size" }, [
  /*#__PURE__*/_createElementVNode("i", {
    style: {"font-size":"1.33rem","padding":"0"},
    class: "bi bi-sd-card-fill"
  })
], -1))
const _hoisted_44 = { class: "indicator-progress" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option_group = _resolveComponent("el-option-group")!
  const _component_editor = _resolveComponent("editor")!
  const _component_el_form = _resolveComponent("el-form")!
  const _directive_loading = _resolveDirective("loading")!
  const _directive_auth = _resolveDirective("auth")!

  return (_openBlock(), _createBlock(_component_el_form, {
    onSubmit: _cache[10] || (_cache[10] = _withModifiers(($event: any) => (_ctx.submit()), ["prevent"])),
    rules: _ctx.rules,
    model: _ctx.formData,
    ref: "formRef"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.t("warningRules.information")), 1)
          ])
        ]),
        _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("label", _hoisted_9, _toDisplayString(_ctx.t("warningRules.category")), 1),
                _createVNode(_component_el_form_item, { prop: "category" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _ctx.formData.category,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.category) = $event)),
                      clearable: "",
                      filterable: "",
                      placeholder: _ctx.t('common.plsSelect'),
                      style: {"width":"100%"},
                      onChange: _ctx.handleCategory
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.category, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item.value,
                            label: item.label,
                            value: item.value
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue", "placeholder", "onChange"])
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.t("warningRules.levelOptions")), 1),
                _createVNode(_component_el_form_item, { prop: "cargo_damage_level" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _ctx.formData.cargo_damage_level,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.cargo_damage_level) = $event)),
                      clearable: "",
                      filterable: "",
                      placeholder: _ctx.t('common.plsSelect'),
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getCargoDamageLevel, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item.value,
                            label: item.label,
                            value: item.value
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue", "placeholder"])
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("label", {
                  class: _normalizeClass(["col-form-label fw-bold fs-6", _ctx.formData.category == '1' ? 'required' : ''])
                }, _toDisplayString(_ctx.t("warningRules.maximumExtensionDays")), 3),
                _createVNode(_component_el_form_item, { prop: "maximum_extension_days" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.formData.maximum_extension_days,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.maximum_extension_days) = $event)),
                      type: "text",
                      placeholder: _ctx.t('common.plsEnter'),
                      clearable: ""
                    }, null, 8, ["modelValue", "placeholder"])
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.t("warningRules.fulfillmentType")), 1),
                _createVNode(_component_el_form_item, { prop: "fulfillment_type" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      class: "w-100",
                      modelValue: _ctx.formData.fulfillment_type,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.fulfillment_type) = $event)),
                      clearable: "",
                      placeholder: _ctx.t('common.plsSelect')
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.fulfillment_type, (group) => {
                          return (_openBlock(), _createBlock(_component_el_option_group, {
                            key: group.label,
                            label: group.label
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.children, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.value,
                                  label: item.label,
                                  value: item.value
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 2
                          }, 1032, ["label"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue", "placeholder"])
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("label", _hoisted_22, _toDisplayString(_ctx.t("warningRules.liquidatedDamages")), 1),
                _createVNode(_component_el_form_item, { prop: "liquidated_damages" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.formData.liquidated_damages,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.liquidated_damages) = $event)),
                      type: "number",
                      placeholder: _ctx.t('common.plsEnter'),
                      clearable: ""
                    }, {
                      prepend: _withCtx(() => [
                        _hoisted_23
                      ]),
                      _: 1
                    }, 8, ["modelValue", "placeholder"])
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("label", _hoisted_26, _toDisplayString(_ctx.t("warningRules.processingMethod")), 1),
                _createVNode(_component_el_form_item, { prop: "processing_method" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.formData.processing_method,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.processing_method) = $event)),
                      type: "text",
                      placeholder: _ctx.t('common.plsEnter'),
                      clearable: ""
                    }, null, 8, ["modelValue", "placeholder"])
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("div", _hoisted_29, [
                _createElementVNode("label", _hoisted_30, _toDisplayString(_ctx.t("warningRules.referenceScheme")), 1),
                _createVNode(_component_el_form_item, { prop: "reference_scheme" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_editor, {
                      modelValue: _ctx.formData.reference_scheme,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formData.reference_scheme) = $event)),
                      id: "scriptEditorReferenceScheme",
                      "api-key": "um8hddq76emgau1ymqr7w6320mhxcygdf5qy8ep56zrl0s9f",
                      init: {
                    height: 500,
                    menubar: false,
                    plugins: [
                      'advlist autolink lists link image charmap print preview anchor',
                      'searchreplace visualblocks code fullscreen',
                      'insertdatetime media table paste code help wordcount',
                    ],
                    toolbar:
                      'undo redo | formatselect | bold italic backcolor forecolor | \
           alignleft aligncenter alignright alignjustify | \
           bullist numlist outdent Underline | link | mceInsertLink | removeformat | help',
                  }
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_31, [
            _createElementVNode("div", _hoisted_32, [
              _createElementVNode("div", _hoisted_33, [
                _createElementVNode("label", _hoisted_34, _toDisplayString(_ctx.t("warningRules.alarmMode")), 1),
                _createVNode(_component_el_form_item, { prop: "alarm_mode" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _ctx.formData.alarm_mode,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formData.alarm_mode) = $event)),
                      clearable: "",
                      filterable: "",
                      multiple: "",
                      placeholder: _ctx.t('common.plsSelect'),
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.alarm_mode, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item.value,
                            label: item.label,
                            value: item.value
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue", "placeholder"])
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_35, [
            _createElementVNode("div", _hoisted_36, [
              _createElementVNode("div", _hoisted_37, [
                _createElementVNode("label", _hoisted_38, _toDisplayString(_ctx.t("warningRules.alarmContent")), 1),
                _createVNode(_component_el_form_item, { prop: "alarm_content" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_editor, {
                      modelValue: _ctx.formData.alarm_content,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formData.alarm_content) = $event)),
                      id: "scriptEditorAlarmContent",
                      "api-key": "um8hddq76emgau1ymqr7w6320mhxcygdf5qy8ep56zrl0s9f",
                      init: {
                    height: 500,
                    menubar: false,
                    plugins: [
                      'advlist autolink lists link image charmap print preview anchor',
                      'searchreplace visualblocks code fullscreen',
                      'insertdatetime media table paste code help wordcount',
                    ],
                    toolbar:
                      'undo redo | formatselect | bold italic backcolor forecolor | \
           alignleft aligncenter alignright alignjustify | \
           bullist numlist outdent Underline | link | mceInsertLink | removeformat | help',
                  }
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ])), [
          [_directive_loading, _ctx.loading]
        ]),
        _createElementVNode("div", _hoisted_39, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-secondary align-self-center me-2",
            onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.backToList && _ctx.backToList(...args)))
          }, [
            _hoisted_40,
            _createTextVNode(" " + _toDisplayString(_ctx.t("common.backToList")), 1)
          ]),
          _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_41, [
            _createElementVNode("span", _hoisted_42, [
              _hoisted_43,
              _createTextVNode(" " + _toDisplayString(_ctx.t("common.saveChanges")), 1)
            ]),
            _createElementVNode("span", _hoisted_44, [
              _createTextVNode(_toDisplayString(_ctx.t("common.pleaseWait")) + " ", 1),
              _hoisted_45
            ])
          ])), [
            [_directive_auth, { auth: ['update'] }]
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["rules", "model"]))
}